module.exports = __webpack_public_path__ + "img/bmp.7cd00eec.png";